import { useEffect } from 'react';
import { camelCaseToKebabCase } from '../helper';
import { useAppConfiguration } from '../AppConfiguration';

const SetBrandingStyles = () => {
    const {branding, styles} = useAppConfiguration();

    useEffect(() => {
        // Set the custom styles for the widget
        // const reactRootElement = document.getElementById(reactRootId);

        for (const [key, value] of Object.entries(styles)) {
            if (!value) {
                // Skip unset values
                continue;
            }

            const propertyName = camelCaseToKebabCase(key);
            document.getElementsByTagName('html')[0].style.setProperty(`--${propertyName}`, value);
        }

        // Import the branding file if set
        if (branding) {
            import('./brandings/' + branding + '.scss').catch(() => {
                // If the branding file does not exist, just send a warning to the developer console instead of killing
                // the whole app
                console.warn('DMG Widget: No branding file defined for "' + branding + '".');
            });
        }
    }, [branding, styles]);

    // We have nothing to render
    return null;
};

export default SetBrandingStyles;
